import './PolicyPages.css';

const DataSecurity = () => {
  return (
    <div className="policy-container" data-testid="data-security">
      <div className="policy-header">
        <h1 className="policy-title">Data Security Policy</h1>
        <p className="policy-subtitle">Last Updated: January 2025</p>
      </div>

      <div className="policy-content">
        <section className="policy-section">
          <h2>1. Our Commitment to Security</h2>
          <p>
            Mediawise Solutions is committed to protecting the confidentiality, integrity, and availability of all information entrusted to us by our clients. We implement industry-standard security measures to safeguard your data.
          </p>
        </section>

        <section className="policy-section">
          <h2>2. Data Storage</h2>
          <p>All client data is stored in secure, encrypted databases. We use:</p>
          <ul>
            <li>Encrypted data storage</li>
            <li>Secure cloud infrastructure</li>
            <li>Regular automated backups</li>
            <li>Restricted access controls</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>3. Data Transmission</h2>
          <p>All data transmitted between your browser and our servers is encrypted using industry-standard SSL/TLS protocols.</p>
        </section>

        <section className="policy-section">
          <h2>4. Access Control</h2>
          <p>Access to client data is strictly limited to authorized consultants and technical staff. All staff are bound by confidentiality agreements.</p>
        </section>

        <section className="policy-section">
          <h2>5. Security Measures</h2>
          <p>Our security infrastructure includes:</p>
          <ul>
            <li>Firewall protection</li>
            <li>Regular security audits</li>
            <li>Intrusion detection systems</li>
            <li>Regular software updates and patches</li>
            <li>Employee security training</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>6. Questions or Concerns</h2>
          <p>
            If you have any questions about our data security practices, please contact us:
          </p>
          <p className="contact-info">
            <strong>Email:</strong> mitch@mediawisesolutions.com.au<br />
            <strong>Phone:</strong> 0409 265 711
          </p>
        </section>
      </div>

      <div className="policy-footer">
        <a href="/" className="back-link">← Back to Home</a>
      </div>
    </div>
  );
};

export default DataSecurity;